import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import PaymentMethods from '../payment';
import CardLogoList from '../payment/logoList';
import PaymentLogo from '../payment/logo';
import { setPaymentMethod } from './actions';

let Icon = class Icon extends React.Component {
  render() {
    return <PaymentLogo brand={this.props.paymentMethod.brand} />;
  }
};

Icon = connect(
  state => ({
    paymentMethod: state.checkout.paymentMethod
  }),
  {}
)(Icon);

let Collapsed = class Collapsed extends React.Component {
  render() {
    const paymentMethod = this.props.paymentMethod;
    return _.isEmpty(paymentMethod) ? (
      <h2 className="checkout-section__title">Payment Method</h2>
    ) : (
      <div className="checkout-section__title checkout-section__title--selected">
        {paymentMethod.brand} {paymentMethod.last4}
      </div>
    );
  }
};

Collapsed = connect(
  state => ({
    paymentMethod: state.checkout.paymentMethod
  }),
  {}
)(Collapsed);

let Expanded = class Expanded extends React.Component {
  handleSelection(method) {
    return this.props
      .setPaymentMethod(method)
      .then(() => this.props.collapse());
  }

  render() {
    return (
      <div className="checkout-form-container">
        <CardLogoList className="right" />
        <h2 className="checkout-section__title checkout-section__title--expanded">
          Payment Method
        </h2>
        <PaymentMethods
          onSelectionSubmit={method => this.handleSelection(method)}
          onNewPaymentSuccess={method => this.handleSelection(method)}
          deliveryAddress={this.props.deliveryAddress}
        />
      </div>
    );
  }
};

Expanded = connect(
  state => ({
    deliveryAddress: state.address
  }),
  { setPaymentMethod }
)(Expanded);

export default {
  Icon,
  Collapsed,
  Expanded
};



// WEBPACK FOOTER //
// ./shared/components/checkoutPage/paymentMethod.js